import floor from "lodash-es/floor";
import React from "react";
import globalTheme from "src/theme";
import styled from "styled-components";

const StarsWrapper = styled.div`
  margin: inherit;
  padding: 0;
  margin-top: ${globalTheme.margins.marginMedium};
  display: flex;
`;

const StarImg = styled.img`
  width: 15px;
  height: 15px;
  &:not(:first-of-type) {
    margin-left: 7px;
  }
`;

interface IProps {
  stars?: number | null;
}

const ProductRating = ({ stars }: IProps): JSX.Element => {
  const MAX_STARS = 5;

  const fullStarsNumber = stars ? floor(stars) : 0;
  const hasHalfStar = stars ? fullStarsNumber !== stars : false;
  const emptyStars = MAX_STARS - fullStarsNumber - (hasHalfStar ? 1 : 0);

  if (stars !== 0 && stars != null) {
    return (
      <StarsWrapper className="product-rating">
        {Array.from(Array(fullStarsNumber).keys()).map(
          (_: {}, index: number) => (
            <StarImg
              key={`fullStar-${index}`}
              src={require("../../../assets/images/fullStar.svg")}
              alt="étoile"
            />
          )
        )}
        {hasHalfStar && (
          <StarImg
            key={`halfStar`}
            src={require("../../../assets/images/halfStar.svg")}
            alt="demi-étoile"
          />
        )}
        {Array.from(Array(emptyStars)).map((_: {}, index: number) => (
          <StarImg
            key={`emptyStar-${index}`}
            src={require("../../../assets/images/emptyStar.svg")}
            alt="étoile-vide"
          />
        ))}
      </StarsWrapper>
    );
  }

  /**
   * When there is no stars
   */
  return (
    <StarsWrapper
      className="product-rating"
      style={{
        opacity: 0,
      }}
    >
      {Array.from(Array(emptyStars)).map((_: {}, index: number) => (
        <StarImg
          key={`emptyStar-${index}`}
          src={require("../../../assets/images/emptyStar.svg")}
          alt="étoile-vide"
        />
      ))}
    </StarsWrapper>
  );
};

export default ProductRating;
